import { CompanyPaginationParams } from '../../domain/entities/company-pagination-params';

export class CompanyPaginationParamsModel extends CompanyPaginationParams {
  override getPath(): string {
    let url: string = '';

    if (this.userId) {
      url += `${this.userId}?`;
    } else {
      url += '?';
    }

    if (this.search_input) {
      url += `search_input=${encodeURIComponent(this.search_input)}`;
    }

    url += `&pagination.IsPaginated=true`;
    url += `&pagination.Page=${this.page}`;
    url += `&pagination.AmountRegistersPage=${this.quantity}`;

    return url;
  }
  override toJson(): Map<string, any> {
    throw new Error('Method not implemented.');
  }
}
